import AdminRoute from "@pages/admin-route/AdminRoute";
import { lazy } from "react";

const AdminLayout = lazy(() => import("@pages/admin/ui/AdminLayout"));
const Dashboard = lazy(() => import("@pages/admin/Dashboard/ui/Dashboard"));
const Clients = lazy(() => import("@pages/admin/Clients/Clients"));
const Client = lazy(() => import("@pages/admin/Client/ui/Client"));
const AiAssistantsPage = lazy(
  () => import("@pages/admin/AiAssistants/AiAssistantsPage"),
);
const AiAssistantPage = lazy(
  () => import("@pages/admin/AiAssistantPage/AiAssistantPage"),
);
const PackagesPage = lazy(
  () => import("@pages/admin/PackagesPage/PackagesPage"),
);
const PackagePage = lazy(() => import("@pages/admin/PackagePage/PackagePage"));
const PaymentsAdmin = lazy(() => import("@pages/admin/Payments/Payments"));
const AdminNews = lazy(() => import("@pages/admin/News/News"));
const AdminFAQ = lazy(() => import("@pages/admin-faq/ui/AdminFAQ"));
const AdminRewards = lazy(
  () => import("@pages/admin/RewardsPage/AdminRewardsPage"),
);
const TicketsPage = lazy(() => import("@pages/admin/TicketsPage/TicketsPage"));
const TicketAdmin = lazy(
  () => import("@pages/admin/TicketAdminPage/AdminTicketPage"),
);
const IntegrationsPage = lazy(
  () => import("@pages/admin/IntegrationsPage/IntegrationsPage"),
);
const IntegrationPage = lazy(
  () => import("@pages/admin/IntegrationPage/IntegrationPage"),
);
const TemplatePage = lazy(
  () => import("@pages/admin/TemplatePage/TemplatePage"),
);
const TemplatesPage = lazy(
  () => import("@pages/admin/TemplatesPage/ui/TemplatesPage"),
);
const AdminBusinessCardsPage = lazy(
  () => import("@pages/admin/BusinessCardsPage/ui/BusinessCardsPage"),
);
const AdminBusinessCardPage = lazy(
  () => import("@pages/admin/BusinessCardsPage/ui/AdminBusinessCardPage"),
);
const NotFound = lazy(() => import("@pages/not-found/NotFound"));

export const adminRoutes = {
  path: "/admin-panel",
  element: <AdminRoute />,
  children: [
    {
      element: <AdminLayout />,
      children: [
        { index: true, element: <Dashboard /> },
        { path: "dashboard", element: <Dashboard /> },
        { path: "clients", element: <Clients /> },
        { path: "client/:id?", element: <Client /> },
        { path: "ai-assistants", element: <AiAssistantsPage /> },
        { path: "ai-assistant/:id?", element: <AiAssistantPage /> },
        { path: "packages", element: <PackagesPage /> },
        { path: "package/:id?", element: <PackagePage /> },
        { path: "payments", element: <PaymentsAdmin /> },
        { path: "templates", element: <TemplatesPage /> },
        { path: "templates/:id?", element: <TemplatePage /> },
        { path: "news", element: <AdminNews /> },
        { path: "faq", element: <AdminFAQ /> },
        { path: "rewards", element: <AdminRewards /> },
        { path: "tickets", element: <TicketsPage /> },
        { path: "business-cards", element: <AdminBusinessCardsPage /> },
        { path: "business-card/:id", element: <AdminBusinessCardPage /> },
        { path: "ticket/:id", element: <TicketAdmin /> },
        { path: "integrations", element: <IntegrationsPage /> },
        { path: "integration/:id", element: <IntegrationPage /> },
        { path: "*", element: <NotFound /> },
      ],
    },
  ],
};
